import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { WebapiService } from '../shared/services/webapi.service';
import { ToastrService } from 'ngx-toastr';
import { CustomValidators } from '../shared/validators/CustomValidators';

declare var window:any;
@Component({
  selector: 'app-schoolcoach',
  templateUrl: './schoolcoach.component.html',
  styleUrls: ['./schoolcoach.component.scss']
})
export class SchoolcoachComponent {
  formSubmitting=false;
  plans:any;
  gymOwnerForm: FormGroup = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])],
    re_email: ['', Validators.compose([Validators.required])],
    password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
    first_name: ['', Validators.compose([Validators.required])],
    re_password: ['', Validators.compose([Validators.required,Validators.minLength(8)])],
    last_name: ['', Validators.compose([Validators.required])],
    form_type: ['schoolcoach', Validators.compose([Validators.required])],
    // number_of_coaches: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
    // number_of_athletes: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],
    number_of_coaches: [''],
    number_of_athletes: [''],
    plan:[''],
    trial:[0]
  },
  { validators: [CustomValidators.MatchValidator('password', 're_password'),CustomValidators.MatchValidator('email', 're_email')] }
  );

  constructor(private fb: FormBuilder, public webApi: WebapiService, private toastrService: ToastrService, public router: Router) {
    this.getPlans('schoolcoach')
    this.gymOwnerForm.get('trial').valueChanges.subscribe(val => {
      if (val==0) {
        this.gymOwnerForm.controls['plan'].setValidators([Validators.required]);
      } else {
        this.gymOwnerForm.controls['plan'].clearValidators();
      }
      this.gymOwnerForm.controls['plan'].updateValueAndValidity();
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }


  changeFormType(formtype){
    this.gymOwnerForm.patchValue({
      plan: "",
    });
    this.getPlans(formtype.replace(/_/g, ""))
  }

  onSigup(form: FormGroup) {
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      if(form.value.plan==""){
        form.value.trial=1
      }
      let trial=form.value.trial
      this.webApi.signup(form.value).subscribe((data: any) => {
        if (data.success) {
          form.reset();
					this.toastrService.success(data.message);
        if(trial!=1 && data.redirecturl && data.redirecturl!=""){
            window.location.href=data.redirecturl;
          }
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.formSubmitting=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }

  getPlans(type){
    this.webApi.getPlans(type).subscribe((data: any) => {
      if (data.success) {
        if(type=="gymowner"){
          let dataplans=data.plans;
          this.plans = [];
          let count=0;
          for(let i=0; i<dataplans.length;i++){
            if(dataplans[i].title.indexOf('Novice-Median')!=-1){
              if(!this.plans['0']){
                this.plans['0']=[];
              }
              this.plans['0'][count]=[];
              this.plans['0'][count]['title']=dataplans[i].title
              this.plans['0'][count]['plan']=dataplans[i]
              this.plans['0'][count]['index']=i
            }else if(dataplans[i].title.indexOf('Novice-Premier')!=-1){
              if(!this.plans['1']){
                this.plans['1']=[];
              }
              this.plans['1'][count]=[];
              this.plans['1'][count]['title']=dataplans[i].title
              this.plans['1'][count]['plan']=dataplans[i]
              this.plans['1'][count]['index']=i
            }else if(dataplans[i].title.indexOf('Novice-Advanced')!=-1){
              if(!this.plans['2']){
                this.plans['2']=[];
              }
              this.plans['2'][count]=[];
              this.plans['2'][count]['title']=dataplans[i].title
              this.plans['2'][count]['plan']=dataplans[i]
              this.plans['2'][count]['index']=i
            }
            count++;
          }
  
          if(this.plans['0']){
            this.plans['0'] = this.plans['0'].filter((val:any)=>{return val});
          }
          
          if(this.plans['1']){
            this.plans['1'] = this.plans['1'].filter((val:any)=>{return val});
          }
          if(this.plans['2']){
            this.plans['2'] = this.plans['2'].filter((val:any)=>{return val});
          }
          this.plans = this.plans.filter((val:any)=>{return val});
        }else if(type=="coach"){
          let dataplans=data.plans;
        this.plans = [];
        let count=0;
        for(let i=0; i<dataplans.length;i++){
          if(dataplans[i].title.indexOf('Novice-Median')!=-1){
            if(!this.plans['0']){
              this.plans['0']=[];
            }
            this.plans['0'][count]=[];
            this.plans['0'][count]['title']=dataplans[i].title
            this.plans['0'][count]['plan']=dataplans[i]
            this.plans['0'][count]['index']=i
          }else if(dataplans[i].title.indexOf('Novice-Advanced')!=-1){
            if(!this.plans['1']){
              this.plans['1']=[];
            }
            this.plans['1'][count]=[];
            this.plans['1'][count]['title']=dataplans[i].title
            this.plans['1'][count]['plan']=dataplans[i]
            this.plans['1'][count]['index']=i
          }else if(dataplans[i].title.indexOf('Novice-Premier')!=-1){
            if(!this.plans['2']){
              this.plans['2']=[];
            }
            this.plans['2'][count]=[];
            this.plans['2'][count]['title']=dataplans[i].title
            this.plans['2'][count]['plan']=dataplans[i]
            this.plans['2'][count]['index']=i
          }
          count++;
        }

        if(this.plans['0']){
          this.plans['0'] = this.plans['0'].filter((val:any)=>{return val});
        }
        
        if(this.plans['1']){
          this.plans['1'] = this.plans['1'].filter((val:any)=>{return val});
        }

        if(this.plans['2']){
          this.plans['2'] = this.plans['2'].filter((val:any)=>{return val});
        }

        this.plans = this.plans.filter((val:any)=>{return val});
        }else if(type=="schoolcoach"){
          let dataplans=data.plans;
        this.plans = [];
        let count=0;
        for(let i=0; i<dataplans.length;i++){
          if(dataplans[i].title.indexOf('Novice-Median')!=-1){
            if(!this.plans['0']){
              this.plans['0']=[];
            }
            this.plans['0'][count]=[];
            this.plans['0'][count]['title']=dataplans[i].title
            this.plans['0'][count]['plan']=dataplans[i]
            this.plans['0'][count]['index']=i
          }else if(dataplans[i].title.indexOf('Novice-Advanced')!=-1){
            if(!this.plans['1']){
              this.plans['1']=[];
            }
            this.plans['1'][count]=[];
            this.plans['1'][count]['title']=dataplans[i].title
            this.plans['1'][count]['plan']=dataplans[i]
            this.plans['1'][count]['index']=i
          }else if(dataplans[i].title.indexOf('Novice-Premier')!=-1){
            if(!this.plans['2']){
              this.plans['2']=[];
            }
            this.plans['2'][count]=[];
            this.plans['2'][count]['title']=dataplans[i].title
            this.plans['2'][count]['plan']=dataplans[i]
            this.plans['2'][count]['index']=i
          }
          count++;
        }

        if(this.plans['0']){
          this.plans['0'] = this.plans['0'].filter((val:any)=>{return val});
        }
        
        if(this.plans['1']){
          this.plans['1'] = this.plans['1'].filter((val:any)=>{return val});
        }

        if(this.plans['2']){
          this.plans['2'] = this.plans['2'].filter((val:any)=>{return val});
        }

        this.plans = this.plans.filter((val:any)=>{return val});

        }

        //this.webApi.setSession(data);
        //this.router.navigateByUrl('/');
      } else {
        this.toastrService.error(data.message);
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.gymOwnerForm.controls;
  }
}


